var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThinCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3172 36.1589C28.2082 36.1589 35.4157 28.9513 35.4157 20.0604C35.4157 11.1695 28.2082 3.96191 19.3172 3.96191C10.4263 3.96191 3.21875 11.1695 3.21875 20.0604C3.21875 28.9513 10.4263 36.1589 19.3172 36.1589Z",
    stroke: "white",
    strokeWidth: 1.61242
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6797 20.8657L16.8994 24.0854L24.9486 16.0361",
    stroke: "white",
    strokeWidth: 1.61242,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThinCheckIcon);
export default __webpack_public_path__ + "static/media/thinCheckIcon.d04bc529d346d029a8f4d37ab20998f2.svg";
export { ForwardRef as ReactComponent };